
/* Layout */
import DeliverDetails from '@/views/deliverManage/apps/detail/index';
import AppsManage from '@/views/deliverManage/apps/index';
import EnvironmentManage from '@/views/deliverManage/environment/index';
import TenantManage from '@/views/deliverManage/tenant/index';
import WarningMessage from '@/views/deliverManage/warninginfo/index';
import Layout from '@/views/layout/Layout';

const deliverManageRouter = {
  path: '/manage/deliver',
  component: Layout,
  props: true,
  type: 'sellers',
  name: 'deliverManage',
  meta: {
    title: '交付管理',
    icon: 'delivery-management',
    requiresAuth: true,
    role: 'market',
    perms: ['Deliver.DeliveryApp.List']
  },
  redirect: '/manage/deliver/apps',
  hidden: false,
  children: [
    {
      path: 'apps',
      name: 'deliveryAppsrManage',
      component: AppsManage,
      meta: {
        title: '交付应用管理',
        icon: 'enterprise-application',
        requiresAuth: true,
        role: 'market',
        perms: ['Deliver.DeliveryApp.List']
      },
      hidden: false
    },
    {
      path: 'environment',
      name: 'deliveryEnvironmentManage',
      component: EnvironmentManage,
      meta: {
        title: '交付环境管理',
        icon: 'environment',
        requiresAuth: true,
        role: 'market',
        perms: ['Deliver.Environment.List']
      },
      hidden: false
    },
    {
      path: 'tenant',
      name: 'tenantManage',
      component: TenantManage,
      meta: {
        title: '租户管理',
        icon: 'tenant-management',
        requiresAuth: true,
        role: 'market',
        perms: ['Deliver.Tenant.List']
      },
      hidden: false
    },
    {
      path: 'apps/:deliverID/detail',
      name: 'deliverDetails',
      component: DeliverDetails,
      meta: {
        title: '详情',
        icon: 'del-management',
        requiresAuth: true,
        role: 'market',
        currentActive: '/manage/deliver/apps',
        perms: ['Deliver.DeliveryApp.Get']
      },
      hidden: true
    },
    {
      path: 'warning',
      name: 'warningMessage',
      component: WarningMessage,
      meta: {
        title: '预警信息',
        icon: 'del-management',
        requiresAuth: true,
        role: 'market',
        perms: ['Market.MarketWarningNotify.List']
      }
    }
  ]
};

export default deliverManageRouter



// WEBPACK FOOTER //
// ./src/router/modules/deliverManage.js